import styled from 'styled-components';
export const Wrapper = styled.div`
	/* background: url('https://pay2mobile.fra1.digitaloceanspaces.com/banner-removebg-preview.png') bottom right no-repeat #dfdfdf; */
	margin: -30px;
	padding-left: 0;
	height: calc(100% + 60px);

	.banner-text {
		padding: 80px 0 20px 0px;

		h1 {
			font-size: 47px;
			line-height: 42px;
			font-weight: bold;
			color: #141414;
			text-transform: uppercase;
		}
		.flat-text {
			font-size: 26px;
			line-height: 39px;
			color: #141414;
			font-weight: 500;
			margin-bottom: 13px;
		}
		i {
			margin-top: 82px;
			display: block;
			font-style: normal;
			font-size: 10px;
			line-height: 16px;
		}
	}
	.carousel{
		.carousel-status{
			display: none;
		}
		.thumbs-wrapper{
			display: none;
		}
	}
`;
